<template>
  <div>
    <spinner v-if="searchingPlan" />
    <div v-else>
      <form-wizard
        @on-complete="savePlan"
        @on-change="scrollToTop"
        title
        subtitle
        color="#8cc63f"
        finish-button-text="Submit"
        shape="square"
      >
        <tab-content title="Plan Details" icon="ti-list">
          <div
            style="
              display: flex;
              align-items: center;
              margin-top: 50px;
              flex-direction: column;
            "
          >
            <div v-if="formType == 'update'" class="col-8">
              <label style="color: #a67f7f">Plan ID: {{ code }}</label>
            </div>
            <div class="col-8" style="margin-top: 15px">
              <label>Plan Name</label>
              <input class="form-control" type="text" required v-model="name" />
            </div>
            <div class="col-8" style="margin-top: 15px">
              <label>Description</label>
              <textarea
                class="form-control"
                type="text"
                required
                v-model="description"
              />
            </div>
            <div class="col-8" style="margin-top: 15px">
              <label>Minimum Allowed Capital</label>
              <input
                class="form-control"
                required
                min="0"
                type="number"
                v-model="min_principal"
              />
            </div>
            <div class="col-8" style="margin-top: 15px">
              <label>Maximum Allowed Capital</label>
              <input
                class="form-control"
                type="number"
                min="0"
                required
                v-model="max_principal"
              />
            </div>
            <div class="col-8" style="margin-top: 15px">
              <label>Currency</label>
              <select class="custom-select" v-model="currency_id">
                <option
                  v-for="currency in currencies"
                  :key="currency.code"
                  :value="currency.id"
                >
                  {{ currency.code }}
                </option>
              </select>
            </div>
            <div class="col-8" style="margin-top: 15px; display: flex">
              <div class="col-8" style="padding: 0">
                <label>Minimum Period</label>
                <input
                  class="form-control"
                  type="number"
                  min="0"
                  required
                  v-model="min_period"
                />
              </div>
              <div style="padding-right: 0" class="col-4">
                <label>Period</label>
                <select
                  style="padding-right: 0"
                  class="custom-select"
                  v-model="period"
                >
                  <option
                    v-for="period in periodList"
                    :key="period.name"
                    :value="period.id"
                  >
                    {{ period.name }}
                  </option>
                </select>
              </div>
            </div>
            <div class="col-8" style="margin-top: 15px; display: flex">
              <div class="col-8" style="padding: 0">
                <label>Withdrawal Notice</label>
                <input
                  class="form-control"
                  type="number"
                  min="0"
                  required
                  v-model="withdrawal_notice"
                />
              </div>
              <div style="padding-right: 0" class="col-4">
                <label>Period</label>
                <select
                  style="padding-right: 0"
                  class="custom-select"
                  v-model="withdrawal_notice_period"
                >
                  <option
                    v-for="period in periodList"
                    :key="period.name"
                    :value="period.id"
                  >
                    {{ period.name }}
                  </option>
                </select>
              </div>
            </div>
            <div class="col-8" style="margin-top: 15px">
              <label>Plan Estimated ROI</label>
              <input
                class="form-control"
                type="text"
                required
                v-model="est_roi"
              />
            </div>
          </div>
        </tab-content>
        <tab-content title="Plan Allocation" icon="ti-pie-chart">
          <div
            style="
              display: flex;
              align-items: center;
              margin-top: 50px;
              flex-direction: column;
            "
          >
            <div
              style="display: flex; justify-content: space-evenly"
              class="col-8"
            >
              <button
                class="btn"
                :class="{
                  'btn-prim': allocation_type == 'clusters',
                  'btn-secondary': allocation_type != 'clusters',
                }"
                style="padding: 10px 25px"
                @click="toggleAllocationType('clusters')"
              >
                Clusters
              </button>
              <button
                class="btn"
                :class="{
                  'btn-prim': allocation_type == 'projects',
                  'btn-secondary': allocation_type != 'projects',
                }"
                style="padding: 10px 25px"
                @click="toggleAllocationType('projects')"
              >
                Projects
              </button>
            </div>
            <div
              style="display: flex; justify-content: center; margin-top: 20px"
              class="col-8"
            >
              <table v-if="allocation_type == 'clusters'" class="col-10">
                <thead>
                  <tr>
                    <th>Select</th>
                    <th>Cluster ID</th>
                    <th>Cluster Name</th>
                    <th>Weight (%)</th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="(
                      plan_cluster_allocation, index
                    ) in plan_cluster_allocations"
                    :key="index"
                  >
                    <td>
                      <input
                        type="checkbox"
                        v-model="plan_cluster_allocation.selected"
                        style="height: 20px; width: 20px"
                      />
                    </td>
                    <td>{{ plan_cluster_allocation.code }}</td>
                    <td>{{ plan_cluster_allocation.name }}</td>
                    <td>
                      <number-input
                        :disableInput="!plan_cluster_allocation.selected"
                        :value="plan_cluster_allocation.weight"
                        v-model="plan_cluster_allocation.weight"
                      ></number-input>
                    </td>
                  </tr>
                </tbody>
              </table>
              <table v-else-if="allocation_type == 'projects'" class="col-10">
                <thead>
                  <tr>
                    <th>Select</th>
                    <th>Project ID</th>
                    <th>Project Name</th>
                    <th>Weight (%)</th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="(
                      plan_project_allocation, index
                    ) in plan_project_allocations"
                    :key="index"
                  >
                    <td>
                      <input
                        type="checkbox"
                        v-model="plan_project_allocation.selected"
                        style="height: 20px; width: 20px"
                      />
                    </td>
                    <td>{{ plan_project_allocation.code }}</td>
                    <td>{{ plan_project_allocation.name }}</td>
                    <td>
                      <number-input
                        :disableInput="!plan_project_allocation.selected"
                        :value="plan_project_allocation.weight"
                        v-model="plan_project_allocation.weight"
                      ></number-input>
                    </td>
                  </tr>
                </tbody>
              </table>
              <!-- <chart-card
                :chartType="'Pie'"
                :chartData="plan_cluster_allocations_chart_data"
              ></chart-card> -->
            </div>
          </div>
        </tab-content>
        <tab-content title="Images, Files, PDFs" icon="ti-files">
          <div
            style="
              display: flex;
              align-items: center;
              margin-top: 50px;
              flex-direction: column;
            "
          >
            <div class="col-8">
              <div
                style="
                  display: flex;
                  align-items: center;
                  flex-direction: column;
                "
              >
                <label class="form-label" style="padding-left: 0"
                  >Plan Image</label
                >
                <div v-if="!plan_image" style="text-align: center">
                  <media-browser
                    filterBy="images"
                    v-model="plan_image"
                    :active="showPlanMediaBrowserModal"
                    @closeRequest="togglePlanMediaBrowserModal"
                  ></media-browser>
                  <i
                    @click="togglePlanMediaBrowserModal"
                    style="font-size: 170px"
                    class="fa fa-image"
                  ></i>
                </div>
                <div
                  style="
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                  "
                  v-else
                >
                  <div
                    style="
                      height: 150px;
                      border: solid rgb(140, 198, 63);
                      width: 200px;
                      border-radius: 15px;
                      display: flex;
                      align-items: center;
                      justify-content: center;
                    "
                  >
                    <img
                      :src="
                        'data:image/' +
                        plan_image.extension +
                        ';base64,' +
                        plan_image.image
                      "
                      alt=""
                    />
                  </div>
                  <div style="margin-top: 15px">
                    <button
                      style="
                        border-radius: 30px;
                        padding-top: 0px;
                        padding-left: 7px;
                        padding-right: 7px;
                        padding-bottom: 0px;
                      "
                      @click="removePlanImage()"
                      type="button"
                      class="btn btn-danger"
                    >
                      <i style="font-size: 12px" class="fa fa-trash"></i>
                      Remove
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-8" style="margin-top: 15px">
              <div
                style="
                  display: flex;
                  align-items: center;
                  justify-content: space-between;
                  margin-bottom: 10px;
                "
              >
                <div>
                  <label>Add Plan Files</label>
                </div>

                <div>
                  <media-browser
                    @fileSelected="addFile"
                    :active="showMediaBrowserModal"
                    @closeRequest="toggleMediaBrowserModal"
                  ></media-browser>
                  <i
                    style="
                      color: rgb(140, 198, 63);
                      font-size: 20px;
                      cursor: pointer;
                    "
                    @click="toggleMediaBrowserModal"
                    class="fa fa-plus-circle"
                  >
                  </i>
                </div>
              </div>
              <div style="border: solid; min-height: 200px; border-width: 2px">
                <table style="width: 100%">
                  <thead>
                    <tr style="text-align: center">
                      <th>#</th>
                      <th>File Name</th>
                      <th>File Type</th>
                      <th>File Size</th>
                      <th>Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      style="text-align: center"
                      v-for="(file, key) in files"
                      :key="key"
                    >
                      <td>{{ key + 1 }}</td>
                      <td>
                        {{ file.caption.split(".").slice(0, -1).join(".") }}
                      </td>
                      <td>{{ file.extension }}</td>
                      <td>{{ bytesToSize(file.size) }}</td>
                      <td>
                        <a
                          style="color: rgb(140, 198, 63) !important"
                          :href="file.url"
                          target="_blank"
                          download
                        >
                          <i class="fa fa-download"></i>
                        </a>
                        <i
                          style="margin-left: 10px; cursor: pointer; color: red"
                          @click="removeFile(key)"
                          class="fa fa-times-circle"
                        ></i>
                      </td>
                    </tr>
                  </tbody>
                </table>
                <!-- <div
                  v-for="(file, key) in files"
                  :key="key"
                  class="form-group"
                  style="margin: 0"
                >
                  <div
                    class="input-group"
                    style="display: flex; align-items: center"
                  >
                    <span
                      :style="'min-width:40px;text-align:center;font-size:14px;padding:0px'"
                      >{{ key + 1 }}.</span
                    >
                    <label style="margin: 0"
                      >{{ file.caption.split(".").slice(0, -1).join(".") }}
                    </label>
                    <label style="margin: 0">{{ file.size }} </label>
                  </div>
                </div> -->
              </div>
            </div>
          </div>
        </tab-content>
      </form-wizard>
    </div>
  </div>
</template>
<script>
import Spinner from "vue-simple-spinner";
import PlanStorer from "../../../../storers/StorePlan";
import PlansFilter from "../../../../filters/PlansFilter";
import PlanFileStorer from "../../../../storers/StorePlanFile";
import PlanClusterWeightStorer from "../../../../storers/StorePlanClusterWeight";
import PlanProjectWeightStorer from "../../../../storers/StorePlanProjectWeight";
import { mapState } from "vuex";
import MediaBrowser from "../../../common/MediaBrowser.vue";
import NumberInput from "../../../common/components/numberInput.vue";
import ChartCard from "../../../../components/Cards/ChartCard.vue";
import CurrenciesFilter from "../../../../filters/CurrenciesFilter";
export default {
  props: ["formType", "activePlanID"],
  data() {
    return {
      periodList: [
        { id: "day", name: "Days" },
        { id: "week", name: "Weeks" },
        { id: "month", name: "Months" },
        { id: "year", name: "Years" },
      ],
      statusList: [
        { id: "active", name: "Active" },
        { id: "inactive", name: "InActive" },
        { id: "notstarted", name: "Not Started" },
        { id: "closed", name: "Closed" },
      ],
      showMediaBrowserModal: false,
      showPlanMediaBrowserModal: false,

      // Plan Details
      name: "",
      code: null,
      description: "",
      min_principal: 0,
      max_principal: 0,
      currency_id: null,
      min_period: 0,
      period: null,
      withdrawal_notice: 0,
      withdrawal_notice_period: null,
      est_roi: null,
      plan_image: null,
      enabled: 1,
      allocation_type: "clusters",
      files: [],
      plan_cluster_allocations: [],
      plan_project_allocations: [],

      plan_cluster_allocations_chart_data: { labels: [], series: [] },
    };
  },
  components: { MediaBrowser, NumberInput, ChartCard, Spinner },

  created: function () {
    var currencyFilter = CurrenciesFilter();
    currencyFilter.is_primary = true;
    currencyFilter.orderBy = ["code", "asc"];
    this.$store
      .dispatch("searchCurrencies", {
        filter: currencyFilter,
        resultMode: "default",
      })
      .then(() => {
        var usdCurrency = this.currencies.find((currency) => {
          return currency.code == "USD";
        });
        this.currency_id = usdCurrency.id;
      });
    this.$store.dispatch("searchClusters").then(() => {
      this.preparePlanClusterAllocation();
    });
    this.$store.dispatch("searchProjects").then(() => {
      this.preparePlanProjectAllocation();
    });
    if (this.formType == "update") {
      var plansFilter = PlansFilter();
      plansFilter.ids = [this.activePlanID];
      plansFilter.with = ["files", "clusterWeights", "projectWeights"];
      this.$store
        .dispatch("searchPlans", {
          filter: plansFilter,
          resultMode: "default",
        })
        .then(() => {
          this.fillForm();
        });
    }
  },
  computed: {
    ...mapState({
      clusters: (state) => state.clusterStore.clusterSearch.clusters,
      projects: (state) => state.projectStore.projectSearch.projects,
      currencies: (state) => state.currencyStore.currencySearch.currencies,
      activePlan: (state) => state.planStore.planSearch.plans[0],
      searchingPlan: (state) => state.planStore.planSearch.searchingPlans,
    }),
  },
  methods: {
    init() {
      this.name = null;
      this.description = null;
      this.min_principal = 0;
      this.max_principal = 0;
      this.currency_id = null;
      this.min_period = 0;
      this.period = null;
      this.withdrawal_notice = 0;
      this.withdrawal_notice_period = null;
      this.est_roi = null;
      this.plan_image = null;
      this.enabled = 1;
    },
    toggleAllocationType(type) {
      this.allocation_type = type;
    },
    fillForm() {
      this.name = this.activePlan.name;
      this.code = this.activePlan.code;
      this.description = this.activePlan.description;
      this.min_principal = this.activePlan.min_principal;
      this.max_principal = this.activePlan.max_principal;
      this.currency_id = this.activePlan.currency_id;
      this.min_period = this.activePlan.min_period;
      this.period = this.activePlan.period;
      this.withdrawal_notice = this.activePlan.withdrawal_notice;
      this.withdrawal_notice_period = this.activePlan.withdrawal_notice_period;
      this.est_roi = this.activePlan.est_roi;
      if (this.activePlan.plan_image) {
        this.plan_image = this.activePlan.plan_image;
      }
      this.allocation_type = this.activePlan.allocation_type;
      this.enabled = this.activePlan.enabled;

      if (this.activePlan.allocation_type == "clusters") {
        this.activePlan.cluster_weights.forEach((clusterWeight) => {
          this.plan_cluster_allocations.forEach((cluster) => {
            if (cluster.cluster_id == clusterWeight.cluster_id) {
              if (clusterWeight.weight > 0) {
                cluster.weight = clusterWeight.weight;
                cluster.selected = true;
              }
            }
          });
        });
      } else if (this.activePlan.allocation_type == "projects") {
        this.activePlan.project_weights.forEach((projectWeight) => {
          this.plan_project_allocations.forEach((project) => {
            if (project.project_id == projectWeight.project_id) {
              if (projectWeight.weight > 0) {
                project.weight = projectWeight.weight;
                project.selected = true;
              }
            }
          });
        });
      }
      if (this.activePlan.files) {
        this.activePlan.files.forEach((file) => {
          this.files.push(file.plan_file);
        });
      }
    },
    scrollToTop() {
      window.scrollTo(0, 0);
    },
    preparePlanClusterAllocation() {
      var labels = [];
      var series = [];
      this.clusters.forEach((cluster) => {
        // labels.push(cluster.name);
        // series.push(0);
        let plan_cluster_allocation = {
          cluster_id: cluster.id,
          code: cluster.code,
          name: cluster.name,
          selected: false,
          weight: 0,
        };
        // this.plan_cluster_allocations_chart_data = {
        //   labels: labels,
        //   series: series,
        // };
        this.plan_cluster_allocations.push(plan_cluster_allocation);
      });
    },
    preparePlanProjectAllocation() {
      var labels = [];
      var series = [];
      this.projects.forEach((project) => {
        // labels.push(project.name);
        // series.push(0);
        let plan_project_allocation = {
          project_id: project.id,
          code: project.code,
          name: project.name,
          selected: false,
          weight: 0,
        };
        // this.plan_project_allocations_chart_data = {
        //   labels: labels,
        //   series: series,
        // };
        this.plan_project_allocations.push(plan_project_allocation);
      });
    },

    toggleMediaBrowserModal() {
      this.showMediaBrowserModal = !this.showMediaBrowserModal;
    },
    togglePlanMediaBrowserModal() {
      this.showPlanMediaBrowserModal = !this.showPlanMediaBrowserModal;
    },
    addFile(file) {
      this.files.push(file);
    },
    removeFile(key) {
      this.files.splice(key, 1);
    },
    removePlanImage() {
      this.plan_image = null;
    },
    bytesToSize(bytes) {
      var sizes = ["Bytes", "KB", "MB", "GB", "TB"];
      if (bytes === 0) return "0 Byte";
      var i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)));
      return Math.round(bytes / Math.pow(1024, i), 2) + " " + sizes[i];
    },
    savePlan() {
      var plan = PlanStorer();

      if (this.formType == "update") {
        plan.id = this.activePlan.id;
        plan.code = this.activePlan.code;
      }
      // Plan Details
      plan.name = this.name;
      plan.description = this.description;
      plan.min_principal = this.min_principal;
      plan.max_principal = this.max_principal;
      plan.currency_id = this.currency_id;
      plan.min_period = parseInt(this.min_period);
      plan.period = this.period;
      plan.withdrawal_notice = parseInt(this.withdrawal_notice);
      plan.withdrawal_notice_period = this.withdrawal_notice_period;
      plan.est_roi = this.est_roi;
      if (this.plan_image) {
        plan.media_id = this.plan_image.id;
      }
      plan.allocation_type = this.allocation_type;
      plan.enabled = this.enabled;

      if (this.allocation_type == "clusters") {
        var planClusterWeights = [];
        this.plan_cluster_allocations.forEach((planClusterWeight) => {
          if (planClusterWeight.selected) {
            var planClusterWeightStorer = PlanClusterWeightStorer();
            if (this.formType == "update") {
              planClusterWeightStorer.plan_id = this.activePlan.id;
            }
            planClusterWeightStorer.cluster_id = planClusterWeight.cluster_id;
            planClusterWeightStorer.weight = planClusterWeight.weight;
            planClusterWeights.push(planClusterWeightStorer);
          }
        });
        plan.clusterWeights = planClusterWeights;
      } else if (this.allocation_type == "projects") {
        var planProjectWeights = [];
        this.plan_project_allocations.forEach((planProjectWeight) => {
          if (planProjectWeight.selected) {
            var planProjectWeightStorer = PlanProjectWeightStorer();
            if (this.formType == "update") {
              planProjectWeightStorer.plan_id = this.activePlan.id;
            }
            planProjectWeightStorer.project_id = planProjectWeight.project_id;
            planProjectWeightStorer.weight = planProjectWeight.weight;
            planProjectWeights.push(planProjectWeightStorer);
          }
        });
        plan.projectWeights = planProjectWeights;
      }

      if (this.files.length != 0) {
        var planFiles = [];
        this.files.forEach((file) => {
          var planFileStorer = PlanFileStorer();
          if (this.formType == "update") {
            planFileStorer.plan_id = this.activePlan.id;
          }
          planFileStorer.media_id = file.id;
          planFiles.push(planFileStorer);
        });
        plan.files = planFiles;
      }

      this.$emit("savePlan", plan);
    },
  },
  watch: {
    // plan_cluster_allocations: {
    //   handler: function (val) {
    //     console.log("val", val);
    //   },
    //   deep: true,
    // },
  },
};
</script>
<style>
.wizard-icon {
  color: rgb(140, 198, 63) !important;
}
.active .wizard-icon {
  color: rgb(255, 255, 255) !important;
}
.wizard-icon-circle {
  border-color: rgb(140, 198, 63) !important;
  background-color: #fafaf7 !important;
}
.stepTitle {
  color: rgb(140, 198, 63) !important;
  margin-top: 5px;
}
.form-control {
  border: 1px solid #ced4da !important;
  background-image: none;
  border-radius: 5px !important;
  padding: 10px;
}
.custom-select {
  background-color: transparent !important;
}
.wizard-btn {
  margin-bottom: 20px !important;
}
.vue-form-wizard.md .wizard-icon-circle {
  width: 100px;
  height: 100px;
  border-radius: 30px;
  font-size: 24px;
}
.vue-form-wizard .wizard-icon-circle .wizard-icon-container.square_shape {
  border-radius: 20px;
  padding: 32px;
}
.vue-form-wizard.md .wizard-nav-pills > li.active > a .wizard-icon {
  font-size: 34px;
}
.vue-form-wizard .wizard-icon-circle .wizard-icon {
  font-size: 34px;
}
/* Chrome, Safari, Edge, Opera */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
input[type="number"] {
  -moz-appearance: textfield;
}

.btn-prim {
  color: #fff;
  background-color: rgb(140, 198, 63);
  border-color: rgb(140, 198, 63);
}
</style>


// WEBPACK FOOTER //
// resources/js/pages/admin/components/forms/planForm.vue